import { render, staticRenderFns } from "./SimpleCookieBanner.vue?vue&type=template&id=2e606f7c&scoped=true&"
import script from "./SimpleCookieBanner.vue?vue&type=script&lang=js&"
export * from "./SimpleCookieBanner.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCookieBanner.vue?vue&type=style&index=0&id=2e606f7c&prod&lang=scss&scoped=true&"
import style1 from "./SimpleCookieBanner.vue?vue&type=style&index=1&id=2e606f7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e606f7c",
  null
  
)

export default component.exports